'use client';
import type { ReactNode } from 'react';
import { useEffect, useState, useCallback } from 'react';
import type { User } from 'firebase/auth';
import { onAuthStateChanged, signOut as firebaseSignOut } from 'firebase/auth';
import { AuthContext } from '../contexts/auth-context';
import { auth } from '@/lib/firebase';
export function AuthProvider({ children }: { children: ReactNode }) {
  const [user, setUser] = useState<User | null>(null);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      setUser(user);
      setLoading(false);
    });
    return () => unsubscribe();
  }, []);
  const signOut = async () => {
    await firebaseSignOut(auth);
  };
  const getIdToken = useCallback(async () => {
    if (user) {
      return await user.getIdToken();
    }
    return null;
  }, [user]);
  
  return (
    <AuthContext.Provider value={{ user, loading, signOut, getIdToken }}>
      {children}
    </AuthContext.Provider>
  );
}
